import { setProperties } from '@ember/object';
function getAssetHost() {
  return document.querySelector('meta[name=dashboard-asset-host]')?.getAttribute('content') ?? '';
}

// This instance initializer simply takes the asset map that was stored by the app initializer and uses it to set the
// appropriate properties on the asset-map service.
export function initialize(appInstance) {
  const assetMapConfig = appInstance.lookup('config:asset-map');
  const assetMapService = appInstance.lookup('service:asset-map');
  if (!assetMapConfig || !assetMapService) {
    // Disabled, e.g. in testing or development
    return;
  }
  setProperties(assetMapService, {
    assetHost: getAssetHost(),
    enabled: true,
    map: assetMapConfig.assets,
    prepend: assetMapConfig.prepend
  });
}
export default {
  initialize
};